import styled from 'styled-components';

/* Lista usada pelos modais de tarefas concluídas e de tarefas não realizadas. */

export const TaskRowList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 8px;
`;

export const TaskRow = styled.div<{ $accent: string }>`
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-left: 4px solid ${({ $accent }) => $accent};
  border-radius: 12px;
  padding: 12px 14px;
  color: var(--text);

  h3 {
    margin: 0 0 6px;
    font-family: var(--font-display);
    font-size: 15px;
    font-weight: 700;
    word-break: break-word;
  }

  p {
    margin: 0 0 8px;
    font-size: 13px;
    color: var(--text-muted);
    word-break: break-word;
  }

  .meta {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-dim);
  }

  .row-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }
`;

export const EmptyList = styled.div`
  border: 1px dashed var(--border-strong);
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  font-size: 13px;
  color: var(--text-dim);
`;

export const RowButton = styled.button<{ $danger?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 10px;
  border: 1px solid ${({ $danger }) => ($danger ? 'var(--accent-rose)' : 'var(--accent)')};
  background: transparent;
  color: ${({ $danger }) => ($danger ? 'var(--accent-rose)' : 'var(--accent)')};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s ease;

  &:hover:not(:disabled) {
    background: ${({ $danger }) =>
        $danger ? 'rgba(251,113,133,0.12)' : 'rgba(43,123,255,0.12)'};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;
